import { twMerge } from 'tailwind-merge';

interface DividerProps {
  className?: string;
}

export default function Divider({ className }: DividerProps) {
  return (
    <div className={twMerge('my-2 border-t border-gray-200', className)} />
  );
}
